export enum TwoFactorMethodTypeOptions {
	TOTP = 'TOTP',
	EMAIL = 'EMAIL',
	PASSKEY = 'PASSKEY'
}

export type TwoFactorMethodType = `${TwoFactorMethodTypeOptions}`;

export enum TwoFactorMethodStatusOptions {
	ACTIVE = 'active',
	DISABLED = 'disabled',
	PENDING_VERIFICATION = 'pending_verification'
}

export type TwoFactorMethodStatus = `${TwoFactorMethodStatusOptions}`;

export interface TwoFactorMethod {
	id: string;
	userId: string;
	methodType: TwoFactorMethodType;
	secret?: string;
	status: TwoFactorMethodStatus;
	isDefault: boolean;
	createdAt: number;
	updatedAt?: number;
}
